import { createSelector } from '@reduxjs/toolkit';
import { tasksNotDeleted } from './tasks-not-deleted';
import { functionNamesById } from './function-names-by-id';
import { singleUserVersion } from '../organization/singleUserVersion';

export const tasksNotDeletedWithFunctionName = createSelector(
  tasksNotDeleted,
  functionNamesById,
  singleUserVersion,
  (tasks, names, singleUser) =>
    tasks.map(function (t) {
      let functionPrefix = '';
      if (!singleUser) {
        functionPrefix = names[t.functionUuid] + ': ';
      }
      return Object.assign({}, t, {
        name: functionPrefix + t.name,
        functionUuid: t.functionUuid,
      });
    }),
);
